import { Notifications } from '@mantine/notifications';

import classes from './NotificationsProvider.module.css';

export const NotificationsProvider = () => (
	<Notifications
		position="top-center"
		autoClose={2000}
		containerWidth="500px"
		transitionDuration={150}
		classNames={{
			root: classes.root,
			notification: classes.test,
		}}
		notificationMaxHeight={40}
	/>
);
